import { Box, Typography } from '@mui/material';
import PathwayLessonVm, { CourseLessonVm } from '../models/LessonVm';

import { ContentType } from '../models/Pathway';
import { Disable } from 'react-disable';
import Grid from '@mui/material/Unstable_Grid2';
import { LessonListSkeleton } from './LessonListSkeleton';
import React from 'react';
import RecentLessonCard from './RecentLessonCard';

interface RecentLessonPanelProps {
  loading: boolean;
  courseLessons?: CourseLessonVm[];
  pathwayLessons?: PathwayLessonVm[];
  contentType?: ContentType;
  onLaunchPathwayLesson?: (
    lessonWindow: Window,
    title: string,
    zonekey: number,
    pathkey: string,
    lessonkey: string,
    resultkey: string
  ) => void;
  onLaunchCourseLesson?: (lesson: CourseLessonVm) => void;
}

const RecentLessonPanel = (props: RecentLessonPanelProps) => {
  return (
    <Box>
      <Typography variant="button" style={{ fontSize: '0.7em' }}>
        RECENTLY ACCESSED
      </Typography>
      <Grid container spacing={1}>
        {props.loading ? (
          <LessonListSkeleton
            direction="row"
            itemsCount={3}
            height={120}
            width={200}
          />
        ) : props.contentType === 'course' ? (
          props.courseLessons?.map((lesson) => {
            const attempt = lesson.latestPortfolioAttempt;
            return (
              <Grid xs key={lesson.lessonkey} className="card-grid">
                <Disable disabled={attempt?.status === 'L'}>
                  <RecentLessonCard
                    courseLesson={lesson}
                    contentType="course"
                    onLaunchCourseLesson={props.onLaunchCourseLesson}
                  />
                </Disable>
              </Grid>
            );
          })
        ) : (
          props.pathwayLessons?.map((lesson) => {
            return (
              <Grid xs key={lesson.lessonkey} className="card-grid">
                <RecentLessonCard
                  pathwayLesson={lesson}
                  contentType="pathway"
                  onLaunchPathwayLesson={props.onLaunchPathwayLesson}
                />
              </Grid>
            );
          })
        )}
      </Grid>
    </Box>
  );
};

export default RecentLessonPanel;
